"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const i0 = require("@angular/core");
class FeatureFlagsService {
    constructor(dataService) {
        this.dataService = dataService;
    }
    getFeatureFlags() {
        return this.dataService.get("featureFlags");
    }
    setFeatureFlags(facilityId, featureFlagCode, isAddFlag) {
        return this.dataService.post("featureFlags/" + facilityId + "/save-feature-flag/" + isAddFlag, featureFlagCode);
    }
}
exports.FeatureFlagsService = FeatureFlagsService;
FeatureFlagsService.ɵfac = function FeatureFlagsService_Factory(t) { return new (t || FeatureFlagsService)(i0.ɵɵinject('dataService')); };
FeatureFlagsService.ɵprov = i0.ɵɵdefineInjectable({ token: FeatureFlagsService, factory: FeatureFlagsService.ɵfac });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(FeatureFlagsService, [{
        type: core_1.Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: core_1.Inject,
                args: ['dataService']
            }] }]; }, null); })();
